import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import {
  columnStateChangedEpic,
  fetchColumnDefinitionReceivedEpic,
  loadPreferenceStateEpic,
  persistPreferenceStateEpic,
} from './preferenceState/preferenceStateEpics';
import {
  fetchColumnDefinitionEpic,
  fetchItemsEpic,
  pollSecondaryMarketBlotterItemsEpic,
  waitUntilBlotterLoadedToSetDefaultFilter,
} from './secondaryMarketOrderBlotterEpics';

export const secondaryMarketOrderBlotterEpic = () =>
  withAppCrashIfException(
    'secondaryMarketOrderBlotter',
    combineEpics(
      fetchItemsEpic(),
      columnStateChangedEpic(),
      fetchColumnDefinitionEpic(),
      fetchColumnDefinitionReceivedEpic(),
      loadPreferenceStateEpic(),
      persistPreferenceStateEpic(),
      pollSecondaryMarketBlotterItemsEpic(),
      waitUntilBlotterLoadedToSetDefaultFilter(),
    ),
  );
